import React, { Component } from 'react';

export default class LayoutContainer extends Component {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    componentWillMount() {

    }
}
